import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getLoyaltyStatusEndpoint } from "./endpoints/getLoyaltyStatus.endpoint";
export const loyaltyApiSlice = createApi({
    reducerPath: "loyaltyApi",
    baseQuery: fetchBaseQuery({ baseUrl: "/" }),
    tagTypes: ["Loyalty"],
    endpoints: (builder) => (Object.assign({}, getLoyaltyStatusEndpoint(builder))),
});
export const { useGetLoyaltyStatusQuery } = loyaltyApiSlice;
//# sourceMappingURL=loyaltyApiSlice.js.map